import { MutationTree } from "vuex";
import { TeamsState, TeamState, TeamStudentState } from "./state";
import { defineVuexName, MODULES } from "../utils";

const mutations: MutationTree<TeamsState> = {
  //setAllStudents
  [defineVuexName(MODULES.TEAMS.COMMITS.SET_ALL_STUDENTS)](s: TeamsState, p: TeamStudentState[]) {
    s.allStudents = p;
    s.allStudentsFetched = true;
    s.teams = [];
  },
  //setTeams
  [defineVuexName(MODULES.TEAMS.COMMITS.SET_TEAMS)](s: TeamsState, p: TeamState[]) {
    s.teams = p;
  },
  //setIsTeamMode
  [defineVuexName(MODULES.TEAMS.COMMITS.SET_IS_TEAM_MODE)](s: TeamsState, p: boolean) {
    s.isTeamMode = p;
  },
  //setLoading
  [defineVuexName(MODULES.TEAMS.COMMITS.SET_IS_LOADING)](s: TeamsState, p: boolean) {
    s.isLoading = p;
  },
  //setSettingModalOpened
  [defineVuexName(MODULES.TEAMS.COMMITS.SET_IS_SETTING_MODAL_OPEN)](s: TeamsState, isOpen: boolean) {
    s.settingModalOpened = isOpen;
  },
  //setEnableTeamModeOnSave
  [defineVuexName(MODULES.TEAMS.COMMITS.SET_IS_ENABLE_TEAM_MODE_ON_SAVE)](s: TeamsState, enabled: boolean) {
    s.enableTeamModeOnSave = enabled;
  },
  //setTeamsRevision
  [defineVuexName(MODULES.TEAMS.COMMITS.SET_TEAMS_REVISION)](s: TeamsState, revision: number) {
    s.revision = revision;
  },
};

export default mutations;
